import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchCompanyDropdown = createAsyncThunk('fetchCompanyDropdown', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/company/dropdown/items?type=${obj.type}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const companyDropdownSlice = createSlice({
    name: 'companyDropdown',
    initialState: {
        loading: false,
        companyDropdown: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyDropdown.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchCompanyDropdown.fulfilled, (state, action) => {
            state.loading = false;
            state.companyDropdown = action.payload
        })
        builder.addCase(fetchCompanyDropdown.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default companyDropdownSlice.reducer